import { api } from './apiService.js';
import { showAlert, ALERT_TYPES } from './alert.js';
import { handleError } from './handleError.js';

export function initForgetPage() {
    const forgetForm = document.getElementById('forget-form');
    if (!forgetForm) return;

    let currentStep = 1;
    let resetToken = null;

    const usernameInput = document.getElementById('username');
    const codeInput = document.getElementById('code');
    const passwordInput = document.getElementById('password');
    const submitButton = document.getElementById('forget-button');
    const alertId = "forget-alert";

    function updateUI() {
        usernameInput.disabled = currentStep !== 1;
        codeInput.disabled = currentStep !== 2;
        passwordInput.disabled = currentStep !== 3;
        submitButton.disabled = currentStep === 4;

        if (currentStep === 1) {
            submitButton.innerHTML = 'ارسال کد';
        }else if (currentStep === 2) {
            submitButton.innerHTML = 'تایید کد';
        }else {
            submitButton.innerHTML = 'ثبت رمز جدید';
        }
    }

    forgetForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        submitButton.disabled = true;

        try {
            if (currentStep === 1) {
                submitButton.innerHTML = 'در حال ارسال...';
                await api.userForgetRequest(usernameInput.value);
                showAlert(alertId, ALERT_TYPES.OK, "حله!", "یه کد به ایمیل و شماره‌ات ارسال شده.");
                currentStep = 2;
            } else if (currentStep === 2) {
                submitButton.innerHTML = 'در حال تایید...';
                const response = await api.userForgetVerify(usernameInput.value, codeInput.value);
                resetToken = response.token;
                showAlert(alertId, ALERT_TYPES.OK, "عالیه!", "کد درسته، حالا رمز جدید رو وارد کن.");
                currentStep = 3;
            } else if (currentStep === 3) {
                submitButton.innerHTML = 'در حال ثبت...';
                await api.userForgetReset(usernameInput.value, resetToken, passwordInput.value);
                showAlert(alertId, ALERT_TYPES.OK, "تمام!", "رمز ورود عوض شد. بریم که وارد بشیم...");
                setTimeout(() => { window.location.href = '/login'; }, 3000);
            } else {
                showAlert(alertId, ALERT_TYPES.WARN, "نکن!", "یه بار زدی دیگه!");
            }
        } catch (error) {
            handleError(error, alertId);
        } finally {
            updateUI();
        }
    });

    updateUI();
}